import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { UserService } from '@service/user/user.service'
import { FormGroup } from '@angular/forms'
import { companyprofile_type_definition, companyprofile_type_sector } from '@model/company-profile/company-profile'
import { User } from '@model/user/user'
import { modelToFormGroup } from 'aautil'
import { MatDialog } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { ToastService } from '@service/toast/toast.service'
import { ComputedImage } from '@model/computed-image'
import { allowedImageExtensions } from '@configuration/image-definitions'
import { messages } from '@configuration/messages'
import { ConfirmDialogComponent } from '@modal/confirm-dialog/confirm-dialog.component';
import { ScrollService } from '@service/scroll.service';
import { LoadingService } from '@service/loading.service';
import { ImageKeys } from '@type/image-keys';
import { UserImageKeys } from '@type/user-image-keys';
import { StateService } from '@service/state.service';
import { filesizeAllowed, getFileExtension } from 'src/app/misc/image-upload-helper';

@Component({
  selector: 'app-create-company-profile',
  templateUrl: './create-company-profile.component.html',
  styleUrls: ['./create-company-profile.component.scss'],
})
export class CreateCompanyProfileComponent implements OnInit {

  public messages = messages

  @ViewChild('stepper')
  public stepper: MatStepper

  public form: FormGroup

  public submitted: boolean

  public set user(user: User) {
    this._user = user
    if (typeof this._user.company_profile != "undefined" && this._user.company_profile != null) {
      this.form = modelToFormGroup(this._user.company_profile)
    }
  }
  public get user(): User {
    return this._user
  }
  private _user: User

  public companyprofile_type_definition_array: string[];
  public companyprofile_type_sector_array: string[];

  public get showLogoStep(): boolean {
    const types_with_logo = ['CARPENTER'];
    const profile = this.user.company_profile;

    return types_with_logo.includes(profile.type);
  }

  constructor(
    private userService: UserService,
    private dialog: MatDialog,
    private toastService: ToastService,
    private scrollService: ScrollService,
    private LoadingService: LoadingService,
    private StateService: StateService,
  ) {
    this.companyprofile_type_definition_array = Object.keys(companyprofile_type_definition);
    this.companyprofile_type_sector_array = Object.keys(companyprofile_type_sector);
    this.userService.userObservable.subscribe(user => {
      if (user)
        this.user = user
    })
  }

  ngOnInit() {
    this.scrollService.scrollToTop()
  }

  public fileSelected(event: any, purpose: UserImageKeys): void {
    const files = event.target.files;

    // TODO use central image upload validation

    if (files && files[0]) {
      for (const file of files) {
        const extension = getFileExtension(file.name).toLowerCase()

        if (!allowedImageExtensions.includes(extension)) {
          this.toastService.showError('Bilder mit dieser Dateiendung (' + extension + ') können nicht hochgeladen werden.')
          return;
        }
      }

      if (!filesizeAllowed(files)) {
        this.toastService.showError(messages.imageUploadMaxSize)
        return
      }

      this.fileDropped(files, purpose)
    }
  }

  public fileDropped(files: any, purpose: UserImageKeys) {
    this.LoadingService.startLoad()

    const file: File = files[0]
    const formData: FormData = new FormData()
    formData.append('images[0][purpose_key]', purpose)
    formData.append('images[0][image]', file)

    this.userService.uploadImage(formData, purpose)
      .then(() => {
        this.user = this.userService.user
      })
      .finally(() => {
        this.LoadingService.stopLoad()
      })
  }

  public nextIfValid() {
    this.submitted = true

    if (this.form.valid) {
      this.stepper.next()
      this.submitted = false
      this.scrollService.scrollToTop()
    }
  }

  public onAutocompleteSelected($event: any) {

    if (!$event.address_components)
      return

    for (const cityDef of $event.address_components) {
      if (cityDef.types.includes('locality')) {
        this.form.controls.city.setValue(cityDef.long_name)
      }
      if (cityDef.types.includes('postal_code')) {
        this.form.controls.zip.setValue(cityDef.long_name)
      }
    }
    this.updateDraft("city")
    this.updateDraft("zip")
  }

  public publishCompanyProfile() {
    this.LoadingService.startLoad()
    this.userService.publishCompanyProfile()
      .catch((e) => {
        console.error(e)
        this.toastService.showError(messages.undefinederror)
      })
      .finally(() => {
        this.LoadingService.stopLoad()
      })
  }

  public updateDraft(att: string) {

    if (!this.form.get(att).valid)
      return

    let data: any = {}
    data[att] = this.form.get(att).value

    // the last true means shadow update
    this.userService.updateCompanyProfile(data, true)
  }

  public deleteImage(imageId: number, key: ImageKeys): Promise<void> {
    return new Promise((resolve, reject) => {
      this.LoadingService.startLoad()
      this.userService.deleteCompanyProfileImage(imageId)
        .then(() => {
          this.LoadingService.stopLoad()
          resolve()
        })
        .catch(err => {
          this.LoadingService.stopLoad()
          reject()
        })
    })
  }

  public discard() {

    const dialogConfig = {
      text: 'Bist Du sicher, dass Du die bisher eingegebenen Informationen verwerfen willst?',
      buttons: [
        {
          text: 'Verwerfen',
          value: 'discard',
        },
        {
          text: 'Behalten',
          value: 'keep',
        },
      ],
    }
    this.LoadingService.stopLoad()
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: dialogConfig,
      disableClose: true,
      panelClass: ConfirmDialogComponent.cssClass
    })
    dialogRef.afterClosed().subscribe(result => {

      if (result == 'discard') {
        this.LoadingService.startLoad()
        this.userService.deleteCompanyProfile()
          .then(() => {
            this.StateService.reload()
          })
      }

    })

  }
}